import { createSelector } from 'reselect';

function selectApm(state: AppState) {
  return state.apm;
}

export const selectIsApmEnabled = createSelector([selectApm], (apm) => {
  return apm.IsApmEnabled;
});
